import React, { useContext, FC } from 'react';
import { Picker } from 'emoji-mart';

import {
  MessageInputEmojiPickerProps,
  TranslationContext,
  useMessageInputContext,
} from 'stream-chat-react';

const EmojiPicker: FC<MessageInputEmojiPickerProps> = ({ small }) => {
  const { t } = useContext(TranslationContext);
  const { emojiPickerIsOpen, emojiPickerRef, onSelectEmoji } = useMessageInputContext();

  if (!emojiPickerIsOpen) {
    return null;
  }

  const className = small
    ? 'str-chat__small-message-input-emojipicker'
    : 'str-chat__input--emojipicker';

  return (
    <div className={className} ref={emojiPickerRef}>
      <Picker
        native
        emoji="point_up"
        title={t('Pick your emoji')}
        onSelect={onSelectEmoji}
        color="#006CFF"
        showPreview={false}
        useButton={true}
      />
    </div>
  );
};

export default EmojiPicker;
